<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.noticeManagement") }}</h4>
    </div>
    <div class="wrap_con type_bt_wrap">
      <div class="mb-5 pb-3">
        <div class="float-end">
          <div class="d-flex">
            <input
              type="text"
              id="searchWord"
              v-model="form.searchWord"
              name="searchWord"
              style="height: 37px"
              class="m-1 form-control"
            />
            <b-form-datepicker
              v-model="form.startDate"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              aria-controls="example-input"
              placeholder="YYYY-MM-DD"
              @input="checkDate"
              class="m-1 input_date"
              label-no-date-selected=""
            ></b-form-datepicker>
            <span style="margin-top: 15px">~</span>
            <b-form-datepicker
              v-model="form.endDate"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              aria-controls="example-input"
              placeholder="YYYY-MM-DD"
              @input="checkDate"
              class="m-1 input_date"
              label-no-date-selected=""
            ></b-form-datepicker>
            <a
              @click="searchBtn"
              href="javascript:void(0)"
              class="searchBtn btn btn-primary btn-sm m-1"
              >{{ $t("support.notice.search") }}</a
            >
          </div>
        </div>
      </div>
      <div>
        <div style="text-align: right">
          <router-link
            to="/management/support/notice/form"
            class="btn btn-primary btn-md mb-2"
            >{{ $t("common.add") }}</router-link
          >
        </div>
        <div>
          <table class="list_tbl">
            <thead>
              <tr>
                <th class="mobile_row">
                  {{ $t("support.notice.title")
                  }}<span class="mobile_vt"
                    >/ {{ $t("support.notice.classify") }} /
                    {{ $t("support.notice.writer") }} / {{ $t("support.notice.date") }} /
                    {{ $t("support.notice.file") }}</span
                  >
                </th>
                <th class="mobile_h">{{ $t("support.notice.writer") }}</th>
                <th class="mobile_h">{{ $t("support.notice.date") }}</th>
                <th class="mobile_h">{{ $t("support.notice.file") }}</th>
                <th class="mobile_h">{{ $t("support.notice.hits") }}</th>
              </tr>
            </thead>
            <tbody v-if="items.length != 0">
              <tr
                v-for="(item, index) in items"
                :key="index"
                @click="goNoticeView(item.boardId)"
                class="active_mouseover"
              >
                <td class="text-left">
                  {{ item.title }}
                </td>
                <td>{{ item.userName }}</td>
                <td>{{ item.firstRegDatetime }}</td>
                <td v-if="item.filecount > 0">
                  <img
                    src="../../../../src/img/background/view_file_icon.png"
                    alt="file"
                  />
                </td>
                <td v-else></td>
                <td>{{ item.hitno }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5">{{ $t("common.noData") }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="items.length != 0" class="paging_nav">
        <a
          href="javascript:void(0)"
          v-if="pagingVO.startPage <= pagingVO.blockSize"
          class="page_select prev_page disabled"
          >이전페이지 이동</a
        >
        <a
          v-else
          class="page_select prev_page"
          @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
          v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
          >이전페이지 이동</a
        >
        <span
          v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
          :key="index"
        >
          <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
            pagingVO.startPage + index
          }}</strong>
          <a
            href="javascript:void(0)"
            v-else
            @click="searchPage(pagingVO.startPage + index)"
            >{{ pagingVO.startPage + index }}</a
          >
        </span>
        <a
          v-if="pagingVO.endPage >= pagingVO.totalPage"
          href="#"
          class="page_select next_page disabled"
          >다음페이지 이동</a
        >
        <a
          v-else
          href="javascript:void(0)"
          @click="searchPage(pagingVO.endPage + 1)"
          v-bind:data-page="pagingVO.endPage + 1"
          class="page_select next_page"
          >다음페이지 이동</a
        >
      </div>
    </div>
  </section>
</template>

<script>
import { getNoticeMgmtList } from "@/api/notice";

export default {
  data() {
    return {
      items: "",
      pagingVO: "",
      form: {
        searchWord: "",
        searchAttributeId: "",
        startDate: "",
        endDate: "",
        page: 1,
      },
      notice: {
        title: "",
        content: "",
        attributeName: "",
        firstRegDatetime: "",
      },
      categoryList: [],
      boardId: "",
      component: null,
      componentName: null,
    };
  },
  methods: {
    async fetchData() {
      try {
        const response = await getNoticeMgmtList(this.form);
        this.items = response.data.pagingVO.dataList;
        this.pagingVO = response.data.pagingVO;
        this.categoryList = response.data.categoryList;
        if (this.pagingVO.endPage > this.pagingVO.totalPage) {
          this.pagingVO.endPage = this.pagingVO.totalPage;
        }
        // 기존 검색 값 유지
        if (response.data.searchObj != null) {
          this.form = response.data.searchObj;
        }
      } catch (error) {
        console.log(error);
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.$store.commit("setPage", page);
      this.fetchData();
    },
    // 검색버튼
    searchBtn() {
      this.form.page = 1;
      this.$store.commit("setSearchWord", this.form.searchWord);
      this.$store.commit("setSearchObj", this.form);
      this.fetchData();
    },
    goNoticeForm() {
      this.$store.commit("setBoardId", "");
      this.$emit("goForm", { component: "NoticeForm" });
    },
    // 날짜 validation
    checkDate() {
      if (this.form.endDate != "" && this.form.startDate != "") {
        if (this.form.endDate < this.form.startDate) {
          alert(this.$t("alert.checkDate"));
          this.form.endDate = "";
          this.form.startDate = "";
          return;
        }
      }
    },
    goNoticeView(boardId) {
      // this.$router.push({ name: "mgmtNoticeView", params: { boardId: boardId } });
      this.$router.push({ name: "mgmtNoticeView", query: { boardId: boardId } });
    },
  },
  mounted() {
    if (this.$store.getters.getSearchObj != "") {
      this.form = this.$store.getters.getSearchObj;
      if (this.$store.getters.getPage != 1) {
        this.form.page = this.$store.getters.getPage;
        this.fetchData(this.form.page);
      } else {
        this.fetchData(this.form.page);
      }
    } else {
      this.fetchData(this.form.page);
    }
  },
};
</script>

<style scoped>
.searchBtn {
  font-size: 1rem;
  padding: 0.375rem 0.75rem;
  height: 35px;
  top: 4px;
}

.b-form-datepicker {
  height: 37px !important;
  padding: 2px 0 15px 0;
}
</style>
